import React, {useEffect, useState} from "react";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {useGlobal} from "../../Store";
import {Button, Card, CardTitleBar, FormField, TextInput} from "../UI";
import {tokens} from "../../theme/tokens";

const ListRatesComponent = ({area = "", business = "", department = ""}) => {


    const [globalState, globalActions] = useGlobal()
    const [ratesList, setRatesList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentRate, setCurrentRate] = useState({});

    useEffect(() => {
        loadRates()
    }, [globalState.observableData.rates])

    function loadRates() {
        let data = new FormData();
        data.append("area_id", area);
        data.append("business_id", business);
        data.append("department_id", department);

        setIsLoading(true)
        postData(Endpoints.RATE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRatesList(res.data.sort((a, b) => {
                        if (a.request_type < b.request_type) {
                            return -1;
                        }
                        if (a.request_type > b.request_type) {
                            return 1;
                        }
                        return 0;
                    }) || []);
                }
            })
            .catch((error) => {
                setIsLoading(false);
            });
    }


    function deleteRate(id) {

        let data = new FormData();
        data.append("id", id);

        setIsLoading(true)
        postData(Endpoints.RATE_DELETE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    loadRates()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function updateRate(id, normalRate, peakRate) {

        let data = new FormData();
        data.append("id", id);
        data.append("normal_rate", normalRate)
        data.append("peak_rate", peakRate)
        setIsLoading(true)
        postData(Endpoints.RATE_UPDATE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    loadRates()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    return (
        <div>
            {ratesList.map((a, b) =>
                <Card padded={false} style={{marginBottom: tokens.spacing[4]}}>
                    <CardTitleBar title={`${a.request_type} | ${a.means_type}`}/>
                    <div style={{padding: 24}}>
                        <FormField label="Normal rate per KM in KES">
                            <TextInput
                                type="number"
                                required={true}
                                value={a.normal_rate}
                                onChange={e => {
                                    let list = ratesList
                                    list[b] = {...a, normal_rate: e.target.value}
                                    setRatesList([...list])
                                }}
                            />
                        </FormField>

                        <FormField label="Peak rate per KM in KES">
                            <TextInput
                                type="number"
                                required={true}
                                value={a.peak_rate}
                                onChange={e => {
                                    let list = ratesList
                                    list[b] = {...a, peak_rate: e.target.value}
                                    setRatesList([...list])
                                }}
                            />
                        </FormField>

                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <Button type="submit" loading={isLoading}
                                    onClick={e => updateRate(a.id, ratesList[b].normal_rate, ratesList[b].peak_rate)}
                            >Update</Button>

                            <Button variant="danger" size="sm"
                                    onClick={e => deleteRate(a.id)}>Delete</Button>
                        </div>
                    </div>
                </Card>
            )}
        </div>
    )
};

export default ListRatesComponent;
